import { render, staticRenderFns } from "./AxAccountMenu.vue?vue&type=template&id=20847d6f&scoped=true&"
import script from "./AxAccountMenu.vue?vue&type=script&lang=ts&"
export * from "./AxAccountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AxAccountMenu.vue?vue&type=style&index=0&id=20847d6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20847d6f",
  null
  
)

export default component.exports